import IconEyeSlashSolid from '@/assets/icons/font_awesome/eye-slash-solid.svg?react';
import IconEyeSolid from '@/assets/icons/font_awesome/eye-solid.svg?react';
import { UI_PRIMITIVE__button_with_icon_animated } from '@/components/ui/UI_PRIMITIVE__button_with_icon_animated';
import { UI_PRIMITIVE__tooltip } from '@/components/ui/UI_PRIMITIVE__tooltip';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_slice_workspace } from '@/hooks/store/use_slices';
import i18n_page_collections from '@/locales/keys/i18n_page_collections.json';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { remote_collection_update_visibility } from '@/state/collection/entity/remote_collection_update_visibility';
import { md } from '@/utils/utils_html';
import { ENUM__workspace_entity_feature } from '@shared/dto/+workspace/workspace_entity/_enums/ENUM__workspace_entity_feature';
import { RequestCollectionUpdateVisibility } from '@shared/dto/collection/_requests/request_collection_update_visibility';
import { DTO__collection } from '@shared/dto/collection/DTO__collection';
import { useTranslation } from 'react-i18next';

interface Props {
  item: DTO__collection;
  isSelected?: boolean;
}

export function СButtonUpdateVisibility({ item, isSelected = false }: Props) {
  const dispatch = use_dispatch();

  const { current_workspace_user } = use_slice_workspace(['current_workspace_user']);

  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_COLLECTIONS);

  const i18n_key_tooltip = t(
    item.is_hidden ? i18n_page_collections.button.update_visibility.tooltip.show : i18n_page_collections.button.update_visibility.tooltip.hide,
  );

  async function onClick(e: React.MouseEvent) {
    e.stopPropagation();

    let request = new RequestCollectionUpdateVisibility();
    request.workspace_id = item.workspace_id;
    request.collection_id = item._id;
    request.is_hidden = !item.is_hidden;

    await dispatch(remote_collection_update_visibility(request));
  }

  if (!current_workspace_user.is_feature_pertmitted(ENUM__workspace_entity_feature.ENTITY_COLLECTION_UPDATE)) return <></>;

  return (
    <UI_PRIMITIVE__tooltip tooltip_title={i18n_key_tooltip} side="right">
      <UI_PRIMITIVE__button_with_icon_animated
        className="w-7"
        size="square-5"
        variant="no-border-on-component"
        onClick={onClick}
        iconClassNameBase={`!w-3.5 !h-3.5 ${md(`${isSelected ? '!text-bar' : '!text-component-item-foreground '}`, ``)}`}
        iconClassNameHovered={'!text-bar-foreground'}
        iconClassNameNonHovered={`!text-bar`}
        Icon={item.is_hidden ? IconEyeSolid : IconEyeSlashSolid}
      />
    </UI_PRIMITIVE__tooltip>
  );
}
